import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { ShoppingCart, Offer, Contract, Issue } from 'src/app/classes';
import { DataService } from 'src/app/services/data.service';
import { ShoppingCartOverviewComponent } from '../../dialog-components/shopping-cart-overview/shopping-cart-overview.component';
import { Router } from '@angular/router';
import { SelectContractDialogComponent } from '../../../lib/contract/components/dialog/select-contract-dialog/select-contract-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SelectIssueDialogComponent } from 'src/app/lib/issue/components/dialog/select-issue-dialog/select-issue-dialog.component';
import { SelectOfferDialogComponent } from 'src/app/lib/offer/components/dialog/select-offer-dialog/select-offer-dialog.component';

@Component({
  selector: 'app-shop-navbar',
  templateUrl: './shop-navbar.component.html',
  styleUrls: ['./shop-navbar.component.css']
})
export class ShopNavbarComponent implements OnInit {

  _cart: ShoppingCart;
  @Input() set cart(cart: ShoppingCart) {
    if (!cart) return;
    this._cart = cart;
    this.hasCart = true;
    if (!cart.products) this.cart.products = [];
    this.cartChange.emit(this._cart);
  }
  get cart(): ShoppingCart {
    return this._cart;
  }
  @Output() cartChange: EventEmitter<any> = new EventEmitter();
  @Output() confirmOrderAnchor: EventEmitter<any> = new EventEmitter();

  hasCart: boolean = false;

  constructor(
    private _dataService: DataService,
    private _dialog: MatDialog,
    private _router: Router
  ) { }

  confirmOrder() {
    this.confirmOrderAnchor.emit();
  }

  ngOnInit(): void {

  }

  openShoppingCartOverview() {
    this._dialog.open(ShoppingCartOverviewComponent, {
      panelClass: "no-padding-dialog-container",
      data: this.cart
    }).afterClosed().subscribe((value: boolean) => {
      if (value) this.confirmOrder();
    });
  }
  /**
   * the method opens the select contract dialog
   */
  selectContract() {
    const dialogRef = this._dialog.open(SelectContractDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result: Contract) => {
      if (result) this._router.navigate(["/edit-contract", result.contractid], {
        queryParams: {
          "shoppingCart": this.cart.guid
        }
      });
    });
  }
  /**
   * the method opens the select issue dialog
   */
  selectIssue(){
    const dialogRef = this._dialog.open(SelectIssueDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result: Issue) => {
      if(result) this._router.navigate(['/issue-details', result.issueid]);
    });
  }
  /**
   * the method opens the select offer dialog
   */
  selectOffer() {
    const dialogRef = this._dialog.open(SelectOfferDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result: Offer) => {
      if (result) this._router.navigate(["/edit-offer", result.offerid], {
        queryParams: {
          "shoppingCart": this.cart.guid
        }
      });
    });
  }

}
